// Figma: "Invoices / Year Dropdown" (node 18702:1425) — a single-select popover listing
// every year the table can be filtered to (newest first), opened from an "Input"-styled
// button in the table's toolbar row.
import React, {useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {Box, ButtonBase, ClickAwayListener, Popper, Typography} from '@mui/material';
import {tokens} from '../../../themes/ThemeCustomization';

import invoiceSelectChevronIcon from '../../../assets/shell/invoice-select-chevron-icon.svg';

const YearFilterDropdown = ({years, selectedYear, onChange}) => {
    const anchorRef = useRef(null);
    const [open, setOpen] = useState(false);

    const handleSelect = (year) => {
        setOpen(false);
        onChange(year);
    };

    return (
        <Box ref={anchorRef} sx={{position: 'relative', flex: 1}}>
            <ButtonBase
                onClick={() => setOpen((prev) => !prev)}
                sx={{
                    width: '100%',
                    height: 36,
                    justifyContent: 'space-between',
                    px: 1.5,
                    border: `1px solid ${tokens.color.neutral200}`,
                    borderRadius: '6px',
                    backgroundColor: tokens.color.white
                }}
            >
                <Typography variant="body2">{selectedYear}</Typography>
                <Box component="img" src={invoiceSelectChevronIcon} alt="" sx={{width: 16, height: 16}} />
            </ButtonBase>

            <Popper open={open} anchorEl={anchorRef.current} placement="bottom-start" sx={{zIndex: 1300, width: anchorRef.current?.offsetWidth}}>
                <ClickAwayListener onClickAway={() => setOpen(false)}>
                    <Box
                        sx={{
                            mt: 0.5,
                            maxHeight: '340px',
                            overflowY: 'auto',
                            backgroundColor: tokens.color.white,
                            border: `1px solid ${tokens.color.neutral200}`,
                            borderRadius: '8px',
                            boxShadow: tokens.shadow.toast,
                            p: 0.5
                        }}
                    >
                        {years.map((year) => (
                            <ButtonBase
                                key={year}
                                onClick={() => handleSelect(year)}
                                sx={{
                                    width: '100%',
                                    justifyContent: 'flex-start',
                                    px: 1,
                                    py: 1,
                                    borderRadius: '6px',
                                    backgroundColor: String(year) === String(selectedYear) ? tokens.color.neutral100 : 'transparent',
                                    '&:hover': {backgroundColor: tokens.color.neutral100}
                                }}
                            >
                                <Typography variant="body2">{year}</Typography>
                            </ButtonBase>
                        ))}
                    </Box>
                </ClickAwayListener>
            </Popper>
        </Box>
    );
};

YearFilterDropdown.propTypes = {
    years: PropTypes.arrayOf(PropTypes.number).isRequired,
    selectedYear: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired
};

export default YearFilterDropdown;
